import React, { useMemo } from 'react';
import { anchorSystemCategories } from '../../config/customConfig';
import css from './ListingPage.module.css';
import { InfoPopup } from '../../components';
import {
  LAST_INSPECTION_DATE_FORMAT_OPTIONS,
  parseLastInspectionDate,
} from '../../util/genericHelpers';

function InfoBlock({ label, content, extraInfo, intl }) {
  return (
    <div className={css.infoBlock}>
      <span>
        {label}
        {extraInfo ? (
          <InfoPopup
            info={intl.formatMessage({
              id: 'EditListingFeaturesForm.waterDepthExtraInfo',
            })}
          />
        ) : (
          ''
        )}
      </span>
      <span>{content} </span>
    </div>
  );
}

function SectionDetailsMaybe({ description, publicData, intl }) {
  const { maxBoatSize, waterDepth, anchorSystemCategories: anchorSystemKey, rules } =
    publicData || {};

  const anchorSystem = useMemo(() => anchorSystemCategories.find(a => a?.key === anchorSystemKey), [
    anchorSystemKey,
  ]);
  const lastInspectionDate = parseLastInspectionDate(publicData?.lastInspection);
  const formattedLastInspection = lastInspectionDate
    ? intl.formatDate(lastInspectionDate, LAST_INSPECTION_DATE_FORMAT_OPTIONS)
    : null;

  const feetLabel = intl.formatMessage({ id: 'ListingPage.feetLabel' });
  const infoBlocks = useMemo(
    () =>
      [
        {
          label: intl.formatMessage({ id: 'ListingPage.maxBoatSize' }),
          content: `${maxBoatSize} ${feetLabel}`,
        },
        {
          label: intl.formatMessage({ id: 'ListingPage.waterDepth' }),
          extraInfo: intl.formatMessage({ id: 'ListingPage.extraInfo' }),
          content: `${waterDepth} ${feetLabel}`,
        },
        formattedLastInspection && {
          label: intl.formatMessage({ id: 'ListingPage.lastInspectionLabel' }),
          content: formattedLastInspection,
        },
        {
          label: intl.formatMessage({ id: 'ListingPage.anchorType' }),
          content: anchorSystem?.label,
        },
      ].filter(Boolean),
    [maxBoatSize, waterDepth, formattedLastInspection, anchorSystem, intl]
  );

  // Remove the HTML bullet points or list markers and format it as plain text
  const formattedDescription = description?.replace(/•/g, '•');

  // Split the content by line breaks for paragraphs (if any)
  const paragraphArray = formattedDescription?.split('\n\n');

  return (
    <div className={css.moreInformation}>
      {infoBlocks.map((block, index) => (
        <InfoBlock
          key={index}
          label={block.label}
          content={block.content}
          extraInfo={block?.extraInfo}
          intl={intl}
        />
      ))}
      <div className={css.description}>
        {paragraphArray?.map((paragraph, index) => (
          <p key={index} style={{ whiteSpace: 'pre-line' }}>
            {paragraph}
          </p>
        ))}
      </div>
      {rules && (
        <div className={css.description}>
          <p>{rules}</p>
        </div>
      )}
    </div>
  );
}

export default SectionDetailsMaybe;
